import React from 'react';
import map from 'lodash/map';

import ImageBlock from './ImageBlock';
import CopyBlock from './CopyBlock';

import { itemStyles } from './styles';

const BigList = ({ items, theme, showExcerptOnSm = false }) => {
  let index = 0;
  return (
    <div>
      {map(items, (item) => {
        if (item.hidden === true) return null;
        index++;
        /* eslint-disable  no-unreachable */
        switch (index % 2) {
          case 0:
            return (
              <CopyImageBlock
                item={item}
                key={`${item.slug}-${index}`}
                theme={theme}
                showExcerptOnSm={showExcerptOnSm}
              />
            );
            break;
          case 1:
          default:
            return (
              <ImageCopyBlock
                item={item}
                key={`${item.slug}-${index}`}
                theme={theme}
                showExcerptOnSm={showExcerptOnSm}
              />
            );
            break;
        }
        /* eslint-enable */
      })}
    </div>
  );
};

const ImageCopyBlock = ({ item, theme, showExcerptOnSm }) => (
  <div {...itemStyles} data-component="ImageCopyBlock">
    <ImageBlock item={item} theme={theme} side="left" />
    <CopyBlock
      item={item}
      theme={theme}
      side="right"
      showExcerptOnSm={showExcerptOnSm}
    />
  </div>
);

const CopyImageBlock = ({ item, theme, showExcerptOnSm }) => (
  <div {...itemStyles} data-component="CopyImageBlock">
    <CopyBlock
      item={item}
      theme={theme}
      side="left"
      showExcerptOnSm={showExcerptOnSm}
    />
    <ImageBlock item={item} theme={theme} side="right" />
  </div>
);

export default BigList;



// WEBPACK FOOTER //
// ./src/components/BigList/BigList.js